$(document).ready(function () {
    var $window = $(window);
    var $body = $('body'); // Select the body element
    var isMobileMenuActive = false;
    var mobileBreakpoint = 800;
    var menuCardCloned = $('.global-nav-main__navigation-wrapper-mobile .global-nav-main__mega-menu-card');
    var menuTabHeight = "";


    // handles hiding menu column on mobile if only mobile cards exist
    var $hiddenElements = $('.sub-column-menu-count');

    $hiddenElements.each(function () {
        var $hiddenElement = $(this);
        var dataCount = $hiddenElement.data('count');

        if (dataCount === 0) {
            $hiddenElement.closest('.global-nav-main__mega-menu-column').addClass('no-mobile-links');
        }
    });


    // Function to close the mega menu
    function closeMegaMenu() {
        $('.global-nav-main__mega-menu').removeClass('show-mega-menu');
        $('.has-child-items a').removeClass('menu-open');
        $body.removeClass('no-scroll'); // Remove the no-scroll class from the body
    }

    // Show/hide the mega menu on click
    $('.has-child-items a').click(function () {
        var clickedMenu = $(this).parent().find('.global-nav-main__mega-menu');
        if (isMobileMenuActive) {
            clickedMenu.slideToggle();
        } else {
            clickedMenu.removeAttr('style'); // Remove the inline style
            clickedMenu.toggleClass('show-mega-menu');
            $body.toggleClass('no-scroll');
            $(this).toggleClass('menu-open');
        }
    });

    // Close the mega menu on click of the close button
    $('.global-nav-main__mega-menu-close').click(function () {
        closeMegaMenu();
    });

    // Toggle mobile menu on burger icon click
    $('.burger-icon').click(function () {
        $('.global-nav-main__navigation-outer-wrapper').toggleClass('open');
        $('.global-nav-main__navigation-wrapper').toggleClass('open');
        // Check if mobile menu is activated or deactivated
        var isActivated = $('.global-nav-main__navigation-outer-wrapper').hasClass('open');
        if (isActivated !== isMobileMenuActive) {
            isMobileMenuActive = isActivated;

            // Trigger window resize event
            $window.trigger('resize');
        }

        if (isMobileMenuActive) {
            $body.addClass('no-scroll'); // Add the no-scroll class to the body
        } else {
            $body.removeClass('no-scroll'); // Remove the no-scroll class from the body
        }
    });

    // Add an event listener to the :before element of the outer wrapper
    $('.global-nav-main__navigation-close-button').click(function () {
        closeMegaMenu();
        $('.global-nav-main__navigation-outer-wrapper').removeClass('open');
        $('.global-nav-main__navigation-wrapper').removeClass('open');

        // Check if mobile menu is deactivated
        if (isMobileMenuActive) {
            isMobileMenuActive = false;

            // Trigger window resize event
            $window.trigger('resize');
        }
    });

    // Mega menu card relocated for mobile menu
    menuCardCloned.clone().addClass('mobile-card').appendTo('.global-nav-main__navigation-wrapper');

    function setMenuHeight() {
        menuTabHeight = $('.global-nav-insurance-tabs__outer-container').outerHeight() - 1;
        $('.global-nav-main__navigation-outer-wrapper').css('height', 'calc(100vh - ' + menuTabHeight + 'px)');
    }

    function resetMobileMenu() {
        isMobileMenuActive = false;
        $('.global-nav-main__navigation-outer-wrapper').removeClass('open');
        $('.global-nav-main__navigation-wrapper').removeClass('open');
        $body.removeClass('no-scroll');
        $('.global-nav-main__mega-menu-column h3').off('click');
        $('.global-nav-main__mega-menu-column ul').removeAttr('style');
        $('.global-nav-main__mega-menu').removeAttr('style');
    }

    function activateMobileMenu() {
        isMobileMenuActive = true;
        $('.global-nav-main__mega-menu-column h3').click(function () {
            $(this).toggleClass('active');
            $(this).next('.global-nav-main__mega-menu-column ul').slideToggle();
        });
    }

    $window.on('resize', function () {
        var windowWidth = $window.width();

        if (windowWidth > mobileBreakpoint) {
            resetMobileMenu();
            closeMegaMenu();
            $('.global-nav-main__navigation-outer-wrapper').removeAttr('style');
        } else {
            if (isMobileMenuActive) {
                resetMobileMenu();
            }
            setMenuHeight();
            if (!isMobileMenuActive) {
                activateMobileMenu();
            }
        }
    });

    $window.trigger('resize');


    // Zendesk open chat widget script

    var breakpoint = 540;

    $('.chatToggle').each(function () {
        var $chatToggle = $(this);
        var isOpen = false;

        function handleChatToggle(e) {
            e.preventDefault();
            var windowWidth = $(window).width();

            if (windowWidth < breakpoint) {
                // Button action to only open widget below 540px
                try {
                    zE('messenger', 'open');
                } catch (e) {
                    try {
                        zE('webWidget', 'open');
                    } catch (e2) {
                        console.error('Failed to open Zendesk widget:', e2);
                    }
                }
            } else {
                // Button action to open and close widget above 540px
                isOpen = !isOpen;
                var action = isOpen ? 'open' : 'close';

                try {
                    zE('messenger', action);
                } catch (e) {
                    try {
                        zE('webWidget', action);
                    } catch (e2) {
                        console.error('Failed to ' + action + ' Zendesk widget:', e2);
                    }
                }
            }
        }

        $chatToggle.on('click', handleChatToggle);
    });

    // Handle window resize
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            var windowWidth = $(window).width();
            if (windowWidth >= breakpoint) {
                // Close the widget when resizing to larger screens
                try {
                    zE('messenger', 'close');
                } catch (e) {
                    try {
                        zE('webWidget', 'close');
                    } catch (e2) {
                        console.error('Failed to close Zendesk widget:', e2);
                    }
                }
            }
        }, 250);
    });


    //Sticky header

    var $header = $('.global-nav-main__outer-container');
    var scrollThreshold = 300;
    var $placeholder = $('<div>');

    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        if (scrollTop > scrollThreshold) {
            if (!$header.hasClass('sticky')) {
                $placeholder.css('height', $header.outerHeight()).insertBefore($header);
                $header.addClass('sticky');
                // Small delay to ensure the initial transform is applied
                setTimeout(function () {
                    $header.addClass('sticky-visible');
                }, 10);
            }
        } else {
            $header.removeClass('sticky sticky-visible');
            $placeholder.remove();
        }
    });
});
